import ContactsShell from "./ContactsShell";
export default function ContactsPage() {
  return <ContactsShell scope="platform" />;
}
